<template>
    <settings-wrapper title="Organization settings" section="Secrets">
        <secrets-listing :level="3" />
    </settings-wrapper>
</template>

<script>
import SettingsWrapper from '@/components/SettingsWrapper.vue'

const SecretsListing = () => import('@/components/SecretsListing.vue')

export default {
    name: 'OrganizationConfigSecrets',
    components: { SecretsListing, SettingsWrapper }
}
</script>
